import apiService from './api.service'

/**
 * Testa o critério personalizado da remessa financeira sem gravar (PHOENIX-943).
 * Responde 200 com { valido, mensagem, totalContratos } mesmo quando o critério é recusado.
 */
const validarCriterioRemessa = (oidUnidade, consultaSql) => {
  return apiService.post('/lottustech/crud-integracao/validarCriterio', { oidUnidade, consultaSql })
}

/**
 * Critérios que o operador pode escolher na tela de remessa, para a unidade selecionada.
 * Responde uma lista de { oid, nome } — vazia quando a unidade não tem critério ativo.
 */
const getCriteriosRemessa = (oidUnidade) => {
  return apiService.get(`/lottustech/crud-integracao/criterios-remessa?oidUnidade=${oidUnidade}`)
}

export { validarCriterioRemessa, getCriteriosRemessa }
